export default "__VITE_ASSET__b56908c1__"